import Vue from 'vue'

var dev = true
Vue.config.silent = !dev
Vue.config.devtools = dev



Vue.mixin({
    data() {
        return {
            querystringObject: {}
        }
    },
    methods: {
        doPost(url, argsObj, callback) {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(argsObj)
            }).then((response) => {
                response.json().then((data) => {
                    callback(data)
                })
            })
        },
        getQuerystringObject() {
            var search = window.location.search.toLowerCase()
            var urlSearchParams = new URLSearchParams(search)
            return Object.fromEntries(urlSearchParams.entries())
        },
    },
    updated() {
        window.lazyLoad.update()
    },
    mounted() {
        this.querystringObject = this.getQuerystringObject()
    }
})
function debounce(fn, delay) {
    var timeoutID = null
    return function () {
        clearTimeout(timeoutID)
        var args = arguments
        var that = this
        timeoutID = setTimeout(function () {
            fn.apply(that, args)
        }, delay)
    }
}


export { Vue, debounce }